import CheckboxField from './CheckboxField';
import { useCheckboxerContext } from './CheckboxerContext';

const CheckboxFieldContainer = (props) => {
  return (
    <CheckboxField
      { ...props }
      { ...useCheckboxerContext() }
    />
  );
};

/**
 * @deprecated This component is considered very legacy and should not be used.
 * It is recommended to avoid any further use of this component due to its outdated nature.
 * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
 */
export default CheckboxFieldContainer;
